import { Criteria } from '../../../../../shared/interfaces/quota.interface';

export class QualificationNamesMapper {
  constructor(private readonly _criteria: Criteria[]) {}

  private _isNested(): boolean {
    return this._criteria.length > 1;
  }

  public names(): string {
    const names = this._criteria
      .map((item) => item.qualification_name)
      .join(', ');
    return this._isNested() ? `${names} nested` : names;
  }
}
